module.exports = __webpack_public_path__ + "img/download.63bdec4c.svg";